import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    curso_escolar_id: Yup.string().required('Debe indicar el curso escolar'),
})

export default validationSchema